/*
 * Bell notices from the server feed. Curators tick "Also show under the
 * bell" on an announcement (`notify: true`); feed.json carries it, and every
 * reader gets it in the bell once per device while it is live (startAt /
 * endAt, audience). No push message is involved.
 *
 * feed.json is already downloaded each session (and early, prefetch.js), so
 * this costs no extra request. Ids added to the bell are remembered on the
 * device (SEEN_KEY), so a notice the reader read or cleared never returns.
 */
import { loadServerFeed } from './server';

const SEEN_KEY = 'baws_bell_seen_v1';
const KEEP_SEEN = 200;

const readSeen = () => {
  try {
    return JSON.parse(localStorage.getItem(SEEN_KEY) || '[]');
  } catch (e) {
    return [];
  }
};

/** Bell notifications for notices this device hasn't had yet. */
export async function newBellNotices({ isLoggedIn, now = Date.now() }) {
  const feed = await loadServerFeed();
  const seen = new Set(readSeen());
  return feed.items
    .filter((it) => it.notify && !seen.has(it.id))
    .filter(
      (it) =>
        (it.startAt == null || it.startAt <= now) &&
        (it.endAt == null || now < it.endAt) &&
        (it.audience === 'all' ||
          (it.audience === 'signedIn' ? isLoggedIn : !isLoggedIn))
    )
    .map((it) => ({
      id: `feed:${it.id}`,
      title: it.title,
      body: it.summary || '',
      image: it.media?.thumbnail || null,
      url: it.link,
      type: 'update',
      timestamp: new Date(it.publishedAt || now).toISOString(),
      read: false,
      source: 'feed', // kept out of the feed's own announcements section
    }));
}

/** Remember that these notices reached the bell on this device. */
export function markNoticesSeen(notices) {
  if (!notices.length) return;
  try {
    const ids = notices.map((n) => n.id.replace(/^feed:/, ''));
    const all = [...ids, ...readSeen().filter((id) => !ids.includes(id))];
    localStorage.setItem(SEEN_KEY, JSON.stringify(all.slice(0, KEEP_SEEN)));
  } catch (e) {
    // storage blocked: the notice may show again next visit; harmless
  }
}
